/* =====================================================================
 * Vinyl-Song-Poster Editor (PROJ-51)
 * =====================================================================
 * Reines Text-Poster (imageless-Typo-Familie). Skelett = kiss-swipe.js.
 *
 * PRINT-MATCH: buildVinylSvg() + alle Konstanten sind 1:1-KOPIE in
 * renderVinylSong() (citymap-server print-mode.js) - IMMER synchron.
 *
 * Layout: Song-Titel + Interpret oben, Liedtext/Gedicht algorithmisch
 * auf konzentrische Schallplatten-Ringe (SVG textPath, deterministische
 * Kapazitaets-Schaetzung + textLength - kein Mess-API), Label mit Datum
 * in Schreibschrift, Tonarm, unten Wunschsatz + Namen. NUR Hochformat.
 * RECHT: Kunde gibt Text selbst ein, keine Lyrics-API (Urheberrecht).
 * ===================================================================== */

(function () {
  'use strict';

  var BACKEND_API_URL = window.VS_BACKEND_API_URL || 'https://tiles.distantlines.de';

  /* ---- Geteilte Layout-Konstanten (MUESSEN dem Server entsprechen) ---- */
  var INK = '#28292d';
  var ACCENT = '#d9cbb4';
  var SANS = "'Outfit', system-ui, sans-serif";
  var SCRIPT = "'Dancing Script', cursive";
  var MONTHS = ['Januar','Februar','M\u00e4rz','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];

  /* ---- Modul-State ---- */
  var root, stage, sectionId;
  var state = {
    song: 'PERFECT',
    artist: 'Ed Sheeran',
    lyrics: 'Hier erscheint dein Songtext oder dein Gedicht oder eure ganz eigene Geschichte',
    date: '',
    claim: 'UNSERE MELODIE F\u00dcR DIE EWIGKEIT',
    names: 'Lisa & Jan',
    c_text: '#28292d',
    orientation: 'portrait',
    bg_color: '#f6f2ea',
    paper_size: '30x40',
    variant_id: '',
    product_type: '',
    frame_color: 'brown'
  };

  function labelLines() {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(state.date || '');
    if (!m) return [];
    return [parseInt(m[3], 10) + '.', MONTHS[parseInt(m[2], 10) - 1], m[1]];
  }

  /* ============================================================
   * buildVinylSvg(cfg) - 1:1-KOPIE im Server (renderVinylSong).
   * Text als Endlos-Strom von aussen nach innen auf Ringe,
   * Kapazitaet deterministisch (Umfang / (FS*CHAR_W)), exakter
   * Sitz per textLength - identisch Chrome-Editor/Server-Playwright.
   * ============================================================ */
  function buildVinylSvg(cfg) {
    var ink = cfg.ink || '#28292d';
    var accent = cfg.accent || '#d9cbb4';
    var FS = 19, CHAR_W = 0.66, SEP = ' \u2022 ';
    var LABEL_FONT = 'Great Vibes, cursive';
    var R_OUT = 424, R_IN = 178, STEP = 28;
    var CX = 500, CY = 500;

    var words = String(cfg.lyrics || '').toUpperCase().replace(/\s+/g, ' ').trim().split(' ').filter(Boolean);
    if (!words.length) words = ['DEIN', 'SONGTEXT'];
    var wi = 0;
    function nextChunk(maxChars) {
      var s = '', guard = 0;
      while (guard < 400) {
        guard++;
        var w = words[wi % words.length];
        var add = (s ? SEP : '') + w;
        if ((s.length + add.length) > maxChars && s) break;
        s += add; wi++;
      }
      return s;
    }
    function escXml(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;');
    }

    var defs = '', texts = '', ringIdx = 0;
    for (var r = R_OUT; r >= R_IN; r -= STEP) {
      var circ = 2 * Math.PI * r;
      var cap = Math.floor(circ / (FS * CHAR_W));
      var pid = 'vring' + ringIdx;
      defs += '<path id="' + pid + '" d="M ' + CX + ' ' + (CY - r) + ' a ' + r + ' ' + r + ' 0 1 1 -0.01 0" fill="none"/>';
      texts += '<text font-family="Outfit, sans-serif" font-size="' + FS + '" font-weight="500" fill="' + ink + '" letter-spacing="1.5">' +
        '<textPath href="#' + pid + '" textLength="' + (circ * 0.995).toFixed(0) + '" lengthAdjust="spacingAndGlyphs">' +
        escXml(nextChunk(cap)) + '</textPath></text>';
      ringIdx++;
    }

    var lines = cfg.label_lines || [];
    var label =
      '<circle cx="500" cy="500" r="160" fill="' + ink + '"/>' +
      '<circle cx="500" cy="500" r="132" fill="none" stroke="' + accent + '" stroke-width="2" opacity="0.55"/>' +
      '<circle cx="500" cy="500" r="112" fill="none" stroke="' + accent + '" stroke-width="2" opacity="0.55"/>' +
      '<circle cx="500" cy="500" r="66" fill="' + accent + '"/>' +
      (lines[0] ? '<text x="500" y="474" text-anchor="middle" font-family="' + LABEL_FONT + '" font-size="30" fill="' + ink + '">' + escXml(lines[0]) + '</text>' : '') +
      (lines[1] ? '<text x="500" y="507" text-anchor="middle" font-family="' + LABEL_FONT + '" font-size="30" fill="' + ink + '">' + escXml(lines[1]) + '</text>' : '') +
      (lines[2] ? '<text x="500" y="541" text-anchor="middle" font-family="' + LABEL_FONT + '" font-size="30" fill="' + ink + '">' + escXml(lines[2]) + '</text>' : '');

    var arm =
      '<circle cx="905" cy="115" r="34" fill="' + accent + '"/>' +
      '<circle cx="905" cy="115" r="12" fill="' + ink + '"/>' +
      '<path d="M 905 115 L 880 330 Q 875 372 838 392 L 800 412" fill="none" stroke="' + ink + '" stroke-width="13" stroke-linecap="round"/>' +
      '<rect x="770" y="398" width="52" height="30" rx="8" transform="rotate(-27 796 413)" fill="' + ink + '"/>';

    return '<svg viewBox="0 0 1000 1000" style="display:block;width:100%;height:auto;" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' + defs + '</defs>' + texts + label + arm + '</svg>';
  }

  function fmFit(el, maxPct) {
    if (!el) return;
    var avail = stage.clientWidth * (maxPct / 100);
    var guard = 0;
    while (el.scrollWidth > avail && guard < 60) {
      var cur = parseFloat(getComputedStyle(el).fontSize);
      if (!cur || cur < 2) break;
      el.style.fontSize = (cur * 0.96) + 'px';
      guard++;
    }
  }

  /* ===================================================================
   * Live-Render - 1:1-Spiegel von renderVinylSong() (Server)
   * =================================================================== */
  function render() {
    if (!stage) return;
    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.setProperty('--blanket-color', state.bg_color);
    grid.style.backgroundColor = state.bg_color;
    var col = state.c_text || INK;
    var fits = [];

    // ---- Kopf: Song + Linie + Interpret (linksbuendig) ----
    var head = document.createElement('div');
    head.style.cssText = 'position:absolute;z-index:3;left:8%;top:5.5%;max-width:84%;';
    head.innerHTML =
      '<div class="vs-song-slot" style="font-family:' + SANS + ';font-weight:700;font-size:5.6cqw;letter-spacing:0.10em;color:' + ACCENT + ';text-transform:uppercase;white-space:nowrap;">' + escHtml(state.song || '') + '</div>' +
      '<div style="height:0.28cqw;background:' + col + ';margin:1.1cqw 0 0.9cqw;width:42cqw;"></div>' +
      '<div class="vs-artist-slot" style="font-family:' + SANS + ';font-weight:500;font-size:2.4cqw;letter-spacing:0.16em;color:' + col + ';text-transform:uppercase;white-space:nowrap;">' + escHtml(state.artist || '') + '</div>';
    grid.appendChild(head);

    // ---- Platte ----
    var disc = document.createElement('div');
    disc.style.cssText = 'position:absolute;z-index:2;left:50%;top:47%;transform:translate(-50%,-50%);width:84cqw;';
    disc.innerHTML = buildVinylSvg({ lyrics: state.lyrics, label_lines: labelLines(), ink: col, accent: ACCENT });
    grid.appendChild(disc);

    // ---- Fuss: Wunschsatz + Namen ----
    var foot = document.createElement('div');
    foot.style.cssText = 'position:absolute;z-index:3;left:50%;bottom:4%;transform:translateX(-50%);text-align:center;width:84%;';
    foot.innerHTML =
      (state.claim ? '<div class="vs-claim-slot" style="font-family:' + SANS + ';font-weight:500;font-size:1.9cqw;letter-spacing:0.24em;color:' + col + ';text-transform:uppercase;border-top:1px solid ' + col + ';display:inline-block;padding-top:1.3cqw;white-space:nowrap;">' + escHtml(state.claim) + '</div>' : '') +
      '<div class="vs-names-slot" style="display:inline-block;font-family:' + SCRIPT + ';font-weight:700;font-size:6.4cqw;color:' + col + ';margin-top:0.4cqw;white-space:nowrap;">' + escHtml(state.names || '') + '</div>';
    grid.appendChild(foot);

    stage.innerHTML = '';
    stage.appendChild(grid);

    fits.push([head.querySelector('.vs-song-slot'), 84], [head.querySelector('.vs-artist-slot'), 84]);
    fits.push([foot.querySelector('.vs-claim-slot'), 80], [foot.querySelector('.vs-names-slot'), 76]);
    fits.forEach(function (f) { if (f[0]) fmFit(f[0], f[1]); });
  }

  function escHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ===================================================================
   * Eingaben (1:1 kiss-swipe-Muster)
   * =================================================================== */
  function bindField(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.value != null) state[key] = el.value;
    el.addEventListener('input', function () { state[key] = el.value; render(); });
  }
  function initColorPickers() {
    root.querySelectorAll('.vs-color[data-key]').forEach(function (p) {
      if (p.value) state[p.dataset.key] = p.value;
      p.addEventListener('input', function () { state[p.dataset.key] = p.value; render(); });
    });
  }
  function initPaperColor() {
    var swatches = root.querySelectorAll('.vs-paper[data-color]');
    function setPaper(hex) {
      state.bg_color = hex;
      swatches.forEach(function (s) {
        s.classList.toggle('current', (s.getAttribute('data-color') || '').toLowerCase() === hex.toLowerCase());
      });
      render();
    }
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) { e.preventDefault(); setPaper(s.getAttribute('data-color')); });
    });
  }

  /* Info-Gluehbirne (Stadt-/Sternkarten-Muster, .tab-help) */
  function initTabHelp() {
    root.querySelectorAll('.tab-help').forEach(function (help) {
      var toggle = help.querySelector('.tab-help__toggle');
      var content = help.nextElementSibling;
      if (!toggle || !content || !content.classList.contains('tab-help__content')) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = content.style.display === 'none' || content.style.display === '';
        content.style.display = open ? 'block' : 'none';
        toggle.classList.toggle('is-active', open);
      });
      var close = content.querySelector('.tab-help__close a');
      if (close) {
        close.addEventListener('click', function (e) {
          e.preventDefault();
          content.style.display = 'none';
          toggle.classList.remove('is-active');
        });
      }
    });
  }

  /* Tabs (Design / Produkt) - main__switcher-Konvention (editor-tabs.css) */
  var formatDefaulted = false;
  function initTabSwitching() {
    var tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    var panels = ['text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          var el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current, fallen damit automatisch.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (nur <=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab - Geburtsposter-Schema, orientierungs-treu (zuhause-Muster)
   * =================================================================== */
  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  function effectiveDim() {
    var d = parsePosterDim(state.paper_size);
    var lo = Math.max(d.w, d.h), sh = Math.min(d.w, d.h);
    return state.orientation === 'landscape' ? { w: lo, h: sh } : { w: sh, h: lo };
  }
  function formatPrice(cents) { return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ','); }
  function syncStageToSize() {
    if (!stage || !state.paper_size) return;
    var d = effectiveDim();
    stage.style.setProperty('--collage-aspect', d.w + ' / ' + d.h);
    var flat = stage.closest('.vs-stage-flat');
    if (flat) flat.style.width = 'calc(min(78vh, 680px) * ' + (d.w / d.h) + ')';
    render();
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('vs-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
  }
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }
  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* ===================================================================
   * Cart-Add - Muster jahreszahlen.js: Render-Job synchron anstossen,
   * dann /cart/add.js mit _print_image_url + Config-Properties.
   * =================================================================== */
  function handleCartAdd() {
    var btn = document.getElementById('vs-cart-btn-' + sectionId);
    if (!(state.lyrics || '').trim()) { alert('Bitte gib euren Text ein.'); return; }
    if (!(state.names || '').trim()) { alert('Bitte trage eure Namen ein.'); return; }
    if (!state.variant_id) { alert('Bitte waehle Produkt und Groesse.'); return; }
    var orig = btn ? btn.textContent : 'In den Warenkorb';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird vorbereitet...'; }

    (async function () {
      try {
        var jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
        var d = effectiveDim();

        var payload = {
          product: 'vinyl-song',
          job_id: jobId,
          variant_id: state.variant_id,
          paper_size: state.paper_size,
          print: { width: d.w, height: d.h, dpi: 300 },
          orientation: state.orientation,
          bg_color: state.bg_color,
          song: (state.song || '').trim(),
          artist: (state.artist || '').trim(),
          lyrics: (state.lyrics || '').trim(),
          label_lines: labelLines(),
          claim: (state.claim || '').trim(),
          names: (state.names || '').trim(),
          c_text: state.c_text || INK
        };

        var printImageUrl = BACKEND_API_URL + '/api/v1/vinyl-song/data/' + jobId + '/';
        try {
          var renderResp = await fetch(BACKEND_API_URL + '/api/v1/vinyl-song/render/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          if (renderResp.ok || renderResp.status === 202) {
            var rd = await renderResp.json().catch(function () { return {}; });
            printImageUrl = rd.print_image_url || printImageUrl;
          }
        } catch (e) { /* Backend nicht erreichbar -> Fallback-URL bleibt */ }

        /* Alle Properties versteckt (_-Prefix) - Warenkorb zeigt nur Produkt + Preis */
        var props = {
          '_Song': [(state.song || '').trim(), (state.artist || '').trim()].filter(Boolean).join(' — '),
          '_Text': (state.lyrics || '').trim().slice(0, 120),
          '_Datum': labelLines().join(' '),
          '_Wunschsatz': (state.claim || '').trim(),
          '_Namen': (state.names || '').trim(),
          '_job_id': jobId,
          '_print_image_url': printImageUrl,
          '_groesse': state.paper_size,
          '_produkt': 'vinyl-song'
        };
        if (state.frame_color && (state.product_type || '').indexOf('Holzrahmen') !== -1) {
          props['_Frame Color'] = state.frame_color;
        }
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        var cartResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] })
        });
        if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

        var cartData = null;
        try {
          cartData = await cartResp.json();
          if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
        } catch (e) { /* skip tracking */ }

        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else window.location.href = '/cart';
      } catch (err) {
        console.error('[vinyl-song] Cart-add failed', err);
        alert('Konnte nicht in den Warenkorb legen - ' + (err.message || 'Unbekannter Fehler'));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = orig || 'In den Warenkorb'; }
      }
    })();
  }

  /* ===================================================================
   * Init - Input-Values aus dem Markup sind Source of Truth (Playbook §1)
   * =================================================================== */
  function init() {
    root = document.querySelector('.vs-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    stage = document.getElementById('vs-stage-' + sectionId);

    bindField('vs-song', 'song');
    bindField('vs-artist', 'artist');
    bindField('vs-lyrics', 'lyrics');
    bindField('vs-date', 'date');
    bindField('vs-claim', 'claim');
    bindField('vs-names', 'names');
    initColorPickers();
    initPaperColor();
    initTabHelp();
    initTabSwitching();
    initWeiterNav();
    initFormatPickers();

    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var btn = document.getElementById('vs-cart-btn-' + sectionId);
    if (btn) btn.addEventListener('click', handleCartAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
